import { DatePickerProps } from '@mui/x-date-pickers';
import { UIUtils } from '@utils';
import { Moment } from 'moment';
import { forwardRef, memo, RefObject, useRef } from 'react';
import Calendar from 'react-calendar';
import { KButton, KColors, KContainer, KPicker, KPickerProps } from 'uikit';

interface IOnShowCalendar {
  ref?: RefObject<HTMLButtonElement | undefined>;
  defaultValue?: Date;
  minDate?: Moment;
  maxDate?: Moment;
  onChange: (v: any) => void;
  value: any;
}

interface IProps
  extends Omit<DatePickerProps<any, Moment>, 'renderInput' | 'value'>,
    KPickerProps {
  defaultValue?: Date;
}

const onShowCalendar = (props: IOnShowCalendar) => {
  const { ref, onChange, defaultValue, minDate, maxDate, ...rest } = props;
  UIUtils.popper.open({
    anchorEl: ref?.current,
    placement: 'bottom-start',
    content: dismiss => (
      <Calendar
        defaultView="month"
        minDetail="year"
        defaultValue={defaultValue}
        onChange={(v: any) => {
          onChange(v);
          dismiss();
        }}
        minDate={minDate ? minDate?.toDate() : undefined}
        maxDate={maxDate?.toDate()}
        {...rest}
      />
    ),
    maxW: 700,
    touchOutsideToDismiss: true,
    withMaxZIndex: true
  });
};

const DateInputCalendar = forwardRef<HTMLInputElement, IProps>((props, ref) => {
  const { defaultValue, minDate, maxDate, onChange, value, disabled, ...rest } =
    props;
  const btnRef = useRef<any>();
  return (
    <KContainer.View dp="flex" row alignItems="center">
      <KPicker.Date
        ref={ref}
        minDate={minDate}
        maxDate={maxDate}
        onChange={onChange}
        value={value}
        disabled={disabled}
        {...rest}
      />

      {!disabled && (
        <KButton.Icon
          marginL={'0.25rem'}
          ref={btnRef}
          icon="ScheduleOutlined"
          background={KColors.primary.normal}
          tintColor={KColors.white}
          br="x"
          onPress={() =>
            onShowCalendar({
              ref: btnRef,
              defaultValue,
              minDate: minDate,
              maxDate: maxDate,
              value,
              onChange
            })
          }
          hasShadow
        />
      )}
    </KContainer.View>
  );
});

DateInputCalendar.displayName = 'Routing.DateInputCalendar';

export default memo(DateInputCalendar);
